import React from 'react';
import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import ContactFormPage from '@/components/ContactFormPage/ContactFormPage';
import { getOrFetchContactForms, getOrFetchCorporateData } from '@/utils/corporateCalls';
import { getLayoutProps } from '@/utils/layout/layout';

import styles from '@/styles/Corporate.module.css';
import { useRouter } from 'next/router';

export default function ContactForm({ contactForm, responsiveLogo, locale }) {
  const router = useRouter();
  if (contactForm.hasOwnProperty('empty')) return;

  const { slug } = router.query;
  const form = contactForm.data.findIndex(el => el.content.slug == slug);

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <main className={styles.mainContainer}>
        <div className={styles.categoriesContainer}>
          {' '}
          <ContactFormPage form={contactForm} locale={locale} index={form} />
          {/* <ContactFormPage form={contactForm} locale={locale} /> */}
        </div>
      </main>
    </>
  );
}

ContactForm.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticPaths({ locales }) {
  const [forms] = await Promise.all([getOrFetchContactForms()]);

  const paths = forms.data.data.map(path => {
    return {
      params: { slug: [path.content.slug] },
    };
  });
  let localizedPaths = [];
  for (const locale of locales) {
    localizedPaths = [...localizedPaths, ...paths.map(path => ({ ...path, locale }))];
  }

  return { paths: localizedPaths, fallback: false };
}

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: corporateData }, { data: contactFormData }] = await Promise.all([
    getOrFetchCorporateData('corporate_page', context.locale),
    getOrFetchCorporateData('contact_form_page', context.locale),
  ]);

  const corporates = corporateData.data;
  const contactForm = contactFormData.data[0]
    ? contactFormData
    : {
        empty: true,
      };

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };
  const locale = context.locale;
  return {
    props: {
      ...layoutProps,
      corporates,
      contactForm,
      messages,
      locale,
    },
  };
}
